import { useQuery } from "@apollo/client";
import { GetClientReferralCodeDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";

export const useClientReferralCodeQuery = () => {
  const clientId = useAuthState((state) => state.data.userInfo.id);

  const result = useQuery(GetClientReferralCodeDocument, {
    skip: !clientId,
    variables: {
      clientId,
    },
  });

  const clientReferralCode = result.data?.clientReferralCode;
  const url = clientReferralCode?.url;
  const code = clientReferralCode?.code;

  return { ...result, url, code };
};
